"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = exports.styles = {
  copy: {
    position: "x1n2onr6",
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    flexShrink: "x2lah0s",
    width: "xmh2cwo",
    height: "xhdxxi3",
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    backgroundColor: "xjbqb8w",
    color: "xqpcjsh x1qfsr1m",
    cursor: "x1ypdohk",
    transitionProperty: "xt3l3uh",
    transitionDuration: "x9i6iqp x1132tj4",
    transitionTimingFunction: "xwji4o3",
    "::before_content": "x1cpjm7i",
    "::before_position": "x1hmns74",
    "::before_top": "xbzqfl4",
    "::before_bottom": "x3al4qo",
    "::before_left": "xrj7q1t",
    "::before_insetInlineStart": null,
    "::before_insetInlineEnd": null,
    "::before_right": "x1rbhi77",
    $$css: true
  },
  copyDone: {
    color: "x1khwwg9 x1bp5kbx",
    $$css: true
  },
  tipTitle: {
    display: "x1lliihq",
    marginBottom: "x1i2h5o5",
    fontFamily: "x1wl88yq",
    fontSize: "xboafo0",
    fontWeight: "x1s688f",
    $$css: true
  },
  tip: {
    display: "x1lliihq",
    maxWidth: "x1c4vidq",
    padding: "x1ouc5qi",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "x18jy0o0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontFamily: "xm3uy08",
    fontSize: "x1iuv88s",
    lineHeight: "x1xfvgam",
    overflowWrap: "xj0a0fe",
    wordBreak: "x1yn0g08",
    color: "x12y22ox",
    backgroundColor: "x13nbq8d",
    boxShadow: "x1478hrd",
    $$css: true
  }
};